<div class="mw-580px-i mnw-320px">
  <h1 mat-dialog-title class="h1-dark fs-20-i fw-500-i">Delete Item</h1>
  <div mat-dialog-content>Are you sure to delete the {{ product.name }}?</div>
  <div mat-dialog-actions>
    <button mat-button (click)="closeDialog()">No</button>
    <button mat-button (click)="deleteItem()" color="warn">Ok</button>
  </div>
</div>
